import { useState, useEffect, useCallback } from "react";
import { createContainer } from "unstated-next";

import { Provider } from "../../interfaces/admin/provider.interface";
import { fetchProvidersByKB } from "../../../api/admin/content-providers/endpoints-referrers";
import { FirebaseAuthContainer } from "../auth/firebase-auth-container.util";
import { isAdminPanel } from "../../utilities/routes/routes.util";
import { UserRole } from "../../enums/user-role.enum";

function useProviders() {
    const { user } = FirebaseAuthContainer.useContainer();
    const [providers, setProviders] = useState<Provider[]>([]);

    const loadProviders = useCallback(() => {
        if (!isAdminPanel || !user) return;

        if (!user?.currentKnowledgeBaseId || user.role === UserRole.user) {
            setProviders([]);
            return;
        }

        fetchProvidersByKB(user.companyId, user.currentKnowledgeBaseId).then(response => {
            setProviders(response.data);
        });
    }, [user]);

    useEffect(() => {
        loadProviders();
    }, [loadProviders]);

    return {
        providers,
        loadProviders
    };
}

export const ProvidersContainer = createContainer(useProviders);
